module.exports = __webpack_public_path__ + "static/img/spring_jianjiePic.c897f6a4.png";